import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

type AppState = {
  appLoading: boolean
  orgs: Organization[]
  subscribers: { [key: string]: () => void }
  invitations: any[]
  notifications: Notification[]
  oldNotifications: Notification[]
  user: any
  isFreeTier: boolean
  systemDate?: string
  isAuthenticated?: boolean
  showToolsOverlay?: boolean
}

export const useAppState = create<AppState>()(
  subscribeWithSelector(() => ({
    appLoading: true,
    orgs: [] as Organization[],
    subscribers: {},
    invitations: [] as Invitation[],
    notifications: [] as Notification[],
    oldNotifications: [] as Notification[],
    user: null as User | null,
    isFreeTier: true,
    isAuthenticated: false,
    systemDate: '',
    showToolsOverlay: false,
  })),
)
